export default {
  rolesView: 'Roles.read',
  rolesUpdate: 'Roles.update',
  permissionsView: 'Permissions.read',
  permissionsCreate: 'Permissions.update',
  phaseFlowUpdate: 'Phase Flow.update',
  phaseDemandUpdate: 'Phase Demand.update',
  phaseConfigUpdate: 'Phase Config.update',
  systemInputUpdate: 'System Inputs.update',
  syncJunctionUpdate: 'Sync Junction.update',
  syncJunctionGet: 'Sync Junction.read',
  systemGenSettingUpdate: 'System General Setting.update',
  faultMonitoringUpdate: 'Fault Monitoring.update',
  generalTimeParametersUpdate: 'General Time Parameters.update',
  nightFlashingUpdate: 'Night Flashing.update',
  streetLightUpdate: 'Street Light.update',
  advanceControlSettingUpdate: 'Advance Control Setting.update',
  xaitsLinkPairingUpdate: 'XAITS Link Pairing.update',
  countdownUpdate: 'Countdown.update',
  goGreenUpdate: 'Go Green.update',
  forcePhaseUpdate: 'Force Phase.update',
  transmitLockingSignalUpdate: 'Transmit Locking Signal.update',
  transmitForcingSignalUpdate: 'Transmit Forcing Signal.update',
  timeWindowsUpdate: 'Time Windows.update',
  vehicleTimeUpdate: 'VA Time.update',
  timeWindowUpdate: 'Time Window.update',
  dayPlanConfigurationUpdate: 'Day Plan Configuration.update',
  fixTimeUpdate: 'Fix Time.update',
  maxTimeUpdate: 'VA Max Time.update',
  minTimeUpdate: 'VA Min Time.update',
  gapTimeUpdate: 'VA Gap Time.update',
  alertGroupCreate: 'Alert Group.write',
  alertGroupUpdate: 'Alert Group.update',
  alertGroupDelete: 'Alert Group.delete',
  junctionClockUpdate: 'Junction Clock.update',
}
